export const Card = ({ children, classes }) => {
  return <div className={`shadow-none ${classes} `}>{children}</div>;
};
